import generatePath from 'utils/generatePath';
import isPicture from 'utils/isPicture';

const endsWithGif = value => typeof value === 'string' && /\.gif$/i.test(value.split(/[?#]/)[0]);

const isAnimatedGif = attachment =>
  attachment?.mimeType === 'image/gif' ||
  endsWithGif(attachment?.name) ||
  endsWithGif(attachment?.httpLink) ||
  endsWithGif(attachment?.storageKey);

/**
 * Resolve an image URL for list icons (`variant: 'thumb'`) or chat bubbles (`variant: 'preview'`).
 * Bubbles must never fall back to the square thumb — only preview → httpLink.
 * GIFs use the original file so the bubble can animate. The JPEG preview is a still.
 */
const resolvePreviewImageSrc = (
  attachment,
  { showImages = true, preferHttpLink = false, variant = 'thumb' } = {},
) => {
  if (!showImages || !attachment) {
    return null;
  }
  const metaUrl = variant === 'preview' ? attachment.meta?.preview : attachment.meta?.thumb;
  const metaSrc = metaUrl ? generatePath(metaUrl) : null;
  const httpSrc =
    attachment.httpLink && isPicture(attachment) ? generatePath(attachment.httpLink) : null;
  if (preferHttpLink || (variant === 'preview' && isAnimatedGif(attachment))) {
    return httpSrc || metaSrc;
  }
  return metaSrc || httpSrc;
};

export default resolvePreviewImageSrc;
